module.exports = __webpack_public_path__ + "static/media/naga.0dc149bd.png";